export default __webpack_public_path__ + "static/media/Path -5.b96ed388.png";